"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "indexHotOpt",
  data: function data() {
    return {
      hotInstance: null,
      TD: null,
      row: null,
      col: null,
      prop: null,
      value: null,
      cellProperties: null
    };
  },
  methods: {
    handleSubmit: function handleSubmit() {
      this.$emit('handleSubmit', this.row);
    },
    handleViewDetail: function handleViewDetail() {
      this.$emit('handleViewDetail', this.row);
    },
    handleCancel: function handleCancel() {
      this.$emit('handleCancel', this.row);
    }
  }
};